export const PAY_MODE = {
  PAYMENT_METHOD: 'paymentMethod',
  ASSIGNED_PAYMENT: 'assignedPayment',
};
